import FormatePrice from '../../utils/FormatePrice';
import { OrderStatusMap } from "../../utils/Enums";
import { FormateDate } from '../../utils/FormateDate';

const CustomerOrderTable = ({ customersOrder }) => {
  console.log(customersOrder)

  return (
    <div className="flow-root bg-white">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto p-4 border">
              <thead className="bg-primaryGray p-1 rounded-t-md rounded-tr-md">
                <tr>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-black">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold capitalize text-black">
                  Order ID
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                  date
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                  Food items
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold capitalize text-black">
                    Total Price
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-center text-sm font-semibold capitalize text-black">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                { customersOrder && (
                  customersOrder?.orderHistories.map((order, index) => (
                    <tr key={index} className="border-b border-b-primaryGray">
                      <td className="px-3 text-xs text-black capitalize font-medium">{index + 1}</td>
                        <td className="px-3 py-4 text-xs text-black whitespace-nowrap flex items-center capitalize">{order?.orderCode}</td>
                      <td className="px-3 text-xs text-black whitespace-nowrap capitalize font-medium">{FormateDate(order?.dateOrder)}</td>
                      <td className="px-3 text-xs capitalize font-semibold">{order?.foodItems}</td>
                      <td className="px-3 text-xs capitalize font-bold">{FormatePrice(order?.price)}</td>
                      <td className={`${OrderStatusMap[order.status] === "failed" ? "bg-[#FFE6E6] text-[#FF0000]" : "bg-[#D9ECD9] text-[#008000]"} capitalize font-semibold rounded-md inline-block w-[120px] text-sm lg:text-md text-center whitespace-nowrap px-3 py-2 my-2 mr-2 rounde-md`}
                    >
                      {OrderStatusMap[order.status] || "Unknown Status"}
                      </td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>
        </div>
    </div>
  )
}

export default CustomerOrderTable